export const AML_CASE_STATUSES = {
  REVIEW: 'REVIEW',
  DOCUMENTS_REQUIRED: 'DOCUMENTS_REQUIRED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
};
